import { Link } from 'react-router-dom';
import { LanguageSelect } from './language-select';
import { useTranslation } from 'react-i18next';
import { Gift01, GraduationHat02, Luggage02 } from '@untitled-ui/icons-react';
import { cn } from '@/lib/utils';
import { useUserInfo } from '@/context/user-info';

type Props = {
  isDrivingLessonsPage: boolean;
  onClickDrivingLessons: () => void;
  onClickBusiness: () => void;
  onClickGiftCard: () => void;
};

export const DesktopNavbar = ({
  isDrivingLessonsPage,
  onClickDrivingLessons,
  onClickBusiness,
  onClickGiftCard,
}: Props) => {
  const { userLanguage } = useUserInfo();
  const { t } = useTranslation();
  return (
    <div className="hidden md:flex items-center justify-start text-sm font-bold text-white">
      {!isDrivingLessonsPage && (
        <Link
          to={`/${userLanguage}/driving-lessons`}
          className="group flex items-center gap-2 py-2.5 px-4 rounded-full bg-transparent hover:bg-bg-primary transition-all duration-300 w-full"
          onClick={onClickDrivingLessons}
          aria-label={t('translation:accessibility.button.go_driving_lessons')}
        >
          <div className="relative flex items-center">
            <GraduationHat02
              className={cn(
                'text-fg-brand size-5 transition-opacity duration-200',
                'opacity-0',
                'group-hover:opacity-100 group-hover:animate-bounceInLeft',
              )}
            />
            <p className="pl-0 group-hover:pl-2 transition-all duration-300 text-white group-hover:text-fg-brand whitespace-nowrap">
              {t('translation:navbar.link.driving_lessons')}
            </p>
          </div>
        </Link>
      )}

      <Link
        to="https://www.rideyego.com/business"
        className="group flex items-center gap-1 py-2.5 px-4 rounded-full bg-transparent hover:bg-bg-primary transition-all duration-300 w-fit"
        onClick={onClickBusiness}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t('translation:accessibility.button.go_business')}
      >
        <Luggage02
          className={cn(
            'text-fg-brand size-5 transition-opacity duration-200',
            'opacity-0',
            'group-hover:opacity-100 group-hover:animate-bounceInLeft',
          )}
        />
        <p className="pl-0 group-hover:pl-1 transition-all duration-300 text-white group-hover:text-fg-brand whitespace-nowrap">
          {t('translation:navbar.link.business')}
        </p>
      </Link>

      <Link
        to="https://www.rideyego.com/gifts"
        className="group flex items-center gap-1 py-2.5 px-4 rounded-full bg-transparent hover:bg-bg-primary transition-all duration-300 w-fit"
        onClick={onClickGiftCard}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t('translation:accessibility.button.go_gifts')}
      >
        <Gift01
          className={cn(
            'text-fg-brand size-5 transition-opacity duration-200',
            'opacity-0',
            'group-hover:opacity-100 group-hover:animate-bounceInLeft',
          )}
        />
        <p className="pl-0 group-hover:pl-1 transition-all duration-300 text-white group-hover:text-fg-brand whitespace-nowrap">
          {t('translation:navbar.link.gift_card')}
        </p>
      </Link>

      <LanguageSelect />
    </div>
  );
};
